module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-user"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.details), function(info, index) {
    return _c('div', {
      class: _vm.getClasses(index)
    }, [_c('h5', [_vm._v(_vm._s(info.title) + "\n          "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(info.subTitle))])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/background.jpg",
      "alt": "..."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "description text-center"
  }, [_vm._v("\n      \"I like the way you work it\n      "), _c('br'), _vm._v(" No diggity\n      "), _c('br'), _vm._v(" I wanna bag it up\"\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59033f74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/UserProfile/UserCard.vue
// module id = 480
// module chunks = 1